import { useDispatch } from 'react-redux';

import { ContextInputDto, ContextOutputDto, ContextTypeRequest } from '@api/ecommerce-xp';
import { getSavedTokenDataFromStorage, saveTokenDataFromStorage } from '@helpers';
import { useAutoFetch } from '@hooks';
import { useNavigation } from '@navigation';
import { saveErrorServiceResponse, saveSuccessServiceResponse, saveTempData, saveUserInput } from '@store';
import { Anything } from '@types';

export enum AvailableErrors {
	ECommerceUnauthorized = 'ECommerceUnauthorized',
}

export const useFetchRetrieveContext = () => {
	const dispatch = useDispatch();
	const contextId = getSavedTokenDataFromStorage<string>('contextId');
	const ott = getSavedTokenDataFromStorage<string>('ott');
	const tokenOAuth = getSavedTokenDataFromStorage<string>('tokenOAuth');
	const { navigate } = useNavigation();
	const state = getSavedTokenDataFromStorage<string>('state');

	let typeRequest = ContextTypeRequest.OTT;
	let tokenRequest = ott;
	if (tokenOAuth) {
		typeRequest = ContextTypeRequest.TOKEN;
		tokenRequest = tokenOAuth;
		if (state) {
			// awaits BE
			typeRequest = ContextTypeRequest.TOKEN_WITHOUT_OTT;
			// tokenRequest = contextId;
		}
	}
	if (contextId) {
		typeRequest = ContextTypeRequest.RECOVER;
		tokenRequest = contextId;
	}
	// if (contextId) {
	// 	// typeRequest = ContextTypeRequest.TokenWithoutOTT;
	// 	typeRequest;
	// 	tokenRequest = contextId;
	// }

	return useAutoFetch<ContextInputDto, ContextOutputDto>({
		data: {
			token: tokenRequest || '',
			type: typeRequest,
			signature: state || '',
		},
		operationKey: 'retrieveContext',
		cache: {
			key: 'retrieveContext',
		},
		onSuccess: (res) => {
			if (res.data) {
				saveTokenDataFromStorage('contextId', res.data.customerInformation?.sessionId || '');
				dispatch(saveSuccessServiceResponse({ retrieveContext: res.data }));
				dispatch(
					saveUserInput({
						solutionIntegrated: res.data?.customerInformation?.integratedSolution,
					})
				);
			}
		},
		onError: (response) => {
			dispatch(saveErrorServiceResponse({ errors: response.errors, type: response.type }));
			if (
				response.errors.filter((err: Anything) => err.code === AvailableErrors.ECommerceUnauthorized).length > 0
			) {
				dispatch(saveTempData({ isUnauthorizedUser: true }));
			} else {
				navigate('serviceError');
			}
		},
	});
};
